export const stripHtml = ( html ) => {
	if( html === null ) {
		return null;
	}
	
	const regex = /(<([^>]+)>)/ig;
	
	return html.replace( regex, '');
}
